import { toast } from 'react-toastify';
import apiClient from '../../store/api/apiClient';

export const getSignedUrl = async ({ name, type, template }) => {
  try {
    const data = await apiClient.post('/admin/get-signed-url', { name, type, template });
    return data.url;
  } catch (error) {
    if (!template) {
      toast.error('Error while downloading the file. Please try again');
    }
    console.log('Error: ', error);
    throw error;
  }
};

export const handleUpdateStatus = async ({ documentId, status }) => {
  try {
    const data = await apiClient.post('/admin/update-status/', {
      status,
      id: documentId,
    });
    if (data.statusCode === 200) {
      return data?.id;
    }
    return data;
  } catch (error) {
    console.log('Error: ', error);
    toast.error('Error while retrying. Please try again');
  }
};
